import React, { useEffect, useMemo } from 'react';
import { useRouter } from 'next/router';
import { Button } from '@havenengineering/module-shared-owners-ui/dist/components/Button';
import clsx from 'clsx';

import { drainDownConfirmation } from '../../../helpers/googleTag';
import styles from './Success.module.scss';

type Props = {
  formData: DrainDownForm;
  bookingId: string;
  drainDown?: DrainDownSlot[];
  reconnection?: DrainDownSlot[];
};

const Success = ({
  bookingId,
  formData,
  drainDown = [],
  reconnection = [],
}: Props) => {
  const router = useRouter();
  const drainDownSlot = useMemo(
    () => drainDown.find((slot) => slot.id === formData.drainDownSlotId),
    [formData.drainDownSlotId, drainDown]
  );
  const reconnectionSlot = useMemo(
    () => reconnection.find((slot) => slot.id === formData.reconnectionSlotId),
    [formData.reconnectionSlotId, reconnection]
  );
  useEffect(() => {
    const confirmDrainDown = async () => {
      await drainDownConfirmation(
        {
          ...formData,
          bookingId,
          drainDownSlot,
          reconnectionSlot,
        },
        {
          successFlag: 'success',
        }
      );
    };

    confirmDrainDown();
  }, [formData, bookingId, drainDownSlot, reconnectionSlot]);

  return (
    <div className={styles.root}>
      <h2 className={clsx(styles.mainTitle, 'owners-typography-8')}>
        Thanks for choosing a drain down service
      </h2>
      <p className="owners-body">
        Your drain down selection has been successfully submitted! You’ll
        receive a confirmation email shortly outlining the details of your
        service.
      </p>
      <Button
        className={styles.button}
        variant="contained"
        fullWidth
        onClick={() => router.push('/')}
      >
        Back to homepage
      </Button>
    </div>
  );
};

export default Success;
